import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import { expandTheme } from 'utils/theme-util';

export const cpStyle = (theme: Theme) => {
  const { palette } = expandTheme(theme);
  return createStyles({
    statusOnColor: {
      color: palette.primary.patina,
      fontWeight: 400,
      marginLeft: theme.spacing(3),
    },
    statusOffColor: {
      color: palette.primary.steelGrey,
      fontWeight: 400,
      marginLeft: theme.spacing(3),
    },
  });
};
